class ShowAll extends HTMLElement {
  constructor(){
    super();
    this.selector = this.dataset.selector;
    this.contentHidden = this.querySelectorAll(`#ShowAllContainer-${this.selector} .showall-content--hidden`);
    this.showAllTrigger = this.querySelector(`#ShowAllTrigger-${this.selector} .js-show-all-trigger`);
    
    this.showAllTrigger.addEventListener("click", () => {
      this.showContent();
    });
  }

  showContent() {
    if (this.contentHidden.length > 0) {
      this.contentHidden.forEach(function(element) {
        element.classList.remove('showall-content--hidden');
      });
    }
  }
  
}

customElements.define('show-all', ShowAll);

class ShowAllPowerSelector extends ShowAll {
  constructor(){
    super();
    this.desktopContainer = document.querySelector(`#ShowAllDesktopContainer-${this.selector}`);
    this.showAllTrigger = this.querySelector(`#ShowAllTrigger-${this.selector} .js-show-all-trigger`);  
    this.showAllTrigger.addEventListener("click", () => {
      this.showContent();
    });
  }

  showContent() {
    this.classList.add('tw-hidden');
    this.desktopContainer.classList.remove('hidden-for--mobile');
  }
  
}

customElements.define('show-all-power-selector', ShowAllPowerSelector);